// extracted by mini-css-extract-plugin
module.exports = {"login_form_container":"login_login_form_container__2OGr6"};